<!-- 账单上报接口内容 -->
<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/commonStructureForThirdPark"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
      return {
        requestBody: {
          "parkCode": "2KKN885S",
          "parkingCode": "190708105000313444714122",
          "actPayCharge": 0,
          "billCode": "2019070814044037248421",
          "collectorName": "wdl",
          "couponList": [{
            "couponCode": "BWTLK1OE5MM",
            "couponName": "3.5小时免费停车券2",
            "couponValue": 6
          }],
          "isAbnormal": 0,
          "isArrear": 0,
          "payDate": "20190708140000",
          "payMode": 4,
          "payModeRemark": "wdl微信支付",
          "payOrigin": 1,
          "payOriginRemark": "wdl",
          "payWay": 1,
          "platformShouldPay": 0,
          "reliefCharge": 0,
          "shouldCharge": 6
        },
        responseCode: {
          "data": {
          }, "message": "业务成功", "resultCode": 0, "status": 1
        },
        infoData: {
          explain: "第三方接入系统主动推送车辆费用账单信息到智慧停车开放平台",
          // sdkcondition: "车场向ydto发送同步数据使用：cn.akeparking.api.ydto.core.send(String cmd,String requestBody)，其中请求参数cmd='upThirdParkCarBill'，body及ResponseBody详情请参见下方详细描述；发送异步数据使用：cn.akeparking.api.ydto.core.sendAsyn(String msgId,String cmd,String requestBody)，同时实现cn.akeparking.api.ydto.core.ClientAsynResponseHandler.onMessage(String cmd,String body)接口方法，处理第三方车场端向ydto发送数据后，ydto返回车场的响应",
          sdkcondition: "cmd=upThirdParkCarBill",
          t_url: this.commonUrls.test+"upThirdParkCarBill",
          p_url: this.commonUrls.prod+"upThirdParkCarBill",
          precondition: "无",
          fitSystem: "第三方停车场",
          pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
          Q_params: [{
            titleName: null,
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' },
              { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [
                { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                { info1: 'parkingCode', info2: '是', info3: 'String', info4: '停车记录编号' },
                { info1: 'billCode', info2: '是', info3: 'String', info4: '支付订单号' },
                { info1: 'payDate', info2: '是', info3: 'String', info4: '支付时间，yyyyMMddHHmmss' },
                { info1: 'actPayCharge', info2: '是', info3: 'Decimal', info4: '车主实付金额' },
                { info1: 'reliefCharge', info2: '是', info3: 'Decimal', info4: '优惠金额' },
                { info1: 'platformShouldPay', info2: '是', info3: 'Decimal', info4: '平台应补扣金额，自动扣费时使用' },
                { info1: 'shouldCharge', info2: '是', info3: 'Decimal', info4: '应收金额' },
                { info1: 'payMode', info2: '是', info3: 'Integer', info4: '支付方式，<url>参考附录:/Api/appendixData</url>' },
                { info1: 'payOrigin', info2: '是', info3: 'Integer', info4: '支付来源，<url>参考附录:/Api/appendixData</url>' },
                { info1: 'payModeRemark', info2: '是', info3: 'String', info4: '支付方式备注' },
                { info1: 'payOriginRemark', info2: '是', info3: 'String', info4: '支付来源备注' },
                { info1: 'collectorName', info2: '是', info3: 'String', info4: '收费员' },
                { info1: 'desc', info2: '是', info3: 'String', info4: '描述' },
                { info1: 'isArrear', info2: '是', info3: 'Integer', info4: '是否欠费补缴记录 0否 1是' },
                { info1: 'isAbnormal', info2: '是', info3: 'Integer', info4: '是否异常账单 0否 1是' },
                { info1: 'couponList', info2: '否', info3: 'JSONArray', info4: '优惠列表' }
                 ]
            },{
                    titleName: 'couponList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'couponType', info2: '是', info3: 'Integer', info4: '优惠类型 0本地优惠 1商家优惠 2自动券优惠 3停车场线上优惠' },
                        { info1: 'couponName', info2: '是', info3: 'String', info4: '优惠名称' },
                        { info1: 'couponCode', info2: '是', info3: 'String', info4: '优惠券的编码' },
                        { info1: 'couponValue', info2: '是', info3: 'Decimal', info4: '抵扣金额,实际的抵扣金额' },
                        ]
            }],
          R_params: [{
            titleName: null,
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' },
              { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [
                { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                { info1: 'platformOnlineActPayCharge', info2: '是', info3: 'Decimal', info4: '真实线上实付' },
                { info1: 'platformOnlineCouponList', info2: '是', info3: 'JSONArray', info4: '实付拆分后的线上优惠详情列表.把platformShouldPay拆分，目前有智慧停车微信优惠,停车场线上优惠' },

            ]
          },{
                    titleName: 'platformOnlineCouponList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'couponOrigin', info2: '是', info3: 'Integer', info4: '优惠来源 0停车场 1智慧停车微信 2第三方' },
                        { info1: 'couponType', info2: '是', info3: 'Integer', info4: '优惠类型 0本地优惠 1商家优惠 2自动券优惠 3停车场线上优惠' },
                        { info1: 'reliefType', info2: '是', info3: 'Integer', info4: '减免类型,跟电子券保持一致，券类型(0免费券 1金额扣减券,费减免固定金额结算 2金额折扣券,车费折扣减免结算 3金额固定值券,车费按券的固定值结算 4时间券,时间减免后再按车费结算 5不同计价券,按不同计价规则车费结算)' },
                        { info1: 'couponName', info2: '是', info3: 'String', info4: '优惠名称' },
                        { info1: 'couponCode', info2: '是', info3: 'String', info4: '优惠券的编码' },
                         { info1: 'faceValue', info2: '是', info3: 'Decimal', info4: '面值' },
                        { info1: 'couponValue', info2: '是', info3: 'Decimal', info4: '抵扣金额,实际的抵扣金额' },
                        ]
            }],
          codeStatus: [{
            titleName: null,
            tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
            td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
          }],
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  // @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/thirdParkForAke/upward/upThirdParkCarBill.vue